module.exports = __webpack_public_path__ + "static/img/bg.6d68502.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/master/bg.png
// module id = 3t3A
// module chunks = 1